export const CREATE_USER_ROLE = 'CREATE_USER_ROLE';
export const GET_ALL_USER_ROLES = 'GET_ALL_USER_ROLES';
export const GET_USER_ROLE = 'GET_USER_ROLE';
export const UPDATE_USER_ROLE = 'UPDATE_USER_ROLE';
export const DELETE_USER_ROLE = 'DELETE_USER_ROLE';
export const GET_ALL_USER_ROLES_SUCCESS = 'GET_ALL_USER_ROLES_SUCCESS';
export const GET_ALL_USER_ROLES_ERROR = 'GET_ALL_USER_ROLES_ERROR';
